import type {DesignerStores} from '@packages/systems/designer/flux';

export * from './utils/actionCreators';
export const getWebhooks = (state: DesignerStores) =>
  state.SiteDataStore.webhooks;
